import { SvgImage, type SvgImageProps } from "@hopper-ui/components";
import { type ElementType } from "react";

export function createSvgImage(src: ElementType) {
    return (props: SvgImageProps) => {
        return <SvgImage {...props} src={src} />;
    };
}
